$( document ).ready(function() {

    $('.devSwitchMfg').on("click", function (event) {
        var ele = event.target;
        var mfg_id = $(ele).data('manufacturer');
        $.ajax({
            method: "POST",
            url: "/api/user/change_manufacturer",
            data: JSON.stringify({
                'manufacturer': mfg_id
            })
        }).done(function (data) {
            location.replace('/');
        });
    });
// adds click event to checkboxes
    var help_desk_inspection_id;
    $('.checkbox-inspection').on("click", function () {

        var id = $(this).attr('id');

        if ($(this).prop('checked')) {
            console.log('checkbox-inspection checked');
            //want to add class selected-inspection-row
            $('.' + id).addClass('selected-inspection-row');
        } else {
            console.log('checkbox-inspection unchecked');
            //want to remove class selected-inspection-row
            $('.' + id).removeClass('selected-inspection-row');
        }

    });

    $('#check-all').on("click", function () {
        var checked = $(this).prop('checked');
        $('#summary-table').find('.checkbox-inspection').prop('checked', checked);
    });

    $('.print-pdf-2').on("click", function(event) {
        var ele = $(event.target);
        var inspection_id = ele.data('inspectionId');
        var ads_id = ele.data('adsId');
        var aim_cr_url = ele.data('aimCrUrl');
        var inspection_type = ele.data('inspectionType');
        var public_status = String(ele.data('publicStatus'));
        var notes_user = String(ele.data('notesUser'));
        var state_code = String(ele.data('stateCode'));
        var data = {
            'inspection_type': inspection_type,
            'state_code': state_code
        };
        var endpoint = '/reports/v2/cr';

        if (inspection_type === 'fca-gdp') {
            data["vp_guid"] = inspection_id;
        }
        else if (inspection_type === 'fmcc'){
            var original_cr_url = ele.data('originalCrUrl');
            data["ads_guid"] = ads_id;
            data["public_status"] = public_status;
            data["original_cr_url"] = original_cr_url;
            data["notes_user"] = notes_user;
            endpoint = '/reports/v2/fmcc_pdf';
        }
        else {
            data["ads_guid"] = ads_id;
        }

        send_request_to_download_file("POST", aim_cr_url + endpoint, data);
    });

    $('#helpDeskDeleteModalConfirm').on("click", function (event) {

        $('#edit_error_modal_text').html('');
        $('#edit_error_modal_indicator').css('display', 'none');

        var inspection_id=$('#hidden_inspection_id').val();
        var reason= $('#helpDeskReason').val();

        console.log('here is the reason ' + reason);
        if (reason == '0') {
            // they must select a reason
            $('#edit_error_modal_text').html('You must choose a reason for the update')
            $('#edit_error_modal_indicator').show();
            console.log('edit_error_modal_indicator should show');

        } else {

            $('#helpDeskDeleteModal').modal('hide');
            $(document.body).css({'cursor': 'wait'});
            $.ajax({
                method: "DELETE",
                url: "/api/manual/delete",
                data: JSON.stringify({
                    "inspection_id": help_desk_inspection_id,
                    "reason_code": reason
                })
            }).done(function (msg) {
                if (msg["result"] == "success") {
                    Snackbar.show( {
                        text: "Successfully deleted", // text of the snackbar
                        duration: 2000, // time in milliseconds after the snackbar autohides, 0 is disabled
                        showAction: false
                    });
                    location.reload();
                } else {
                    Snackbar.show({
                        text: "There was an error deleting the record - " + msg["error"], // text of the snackbar
                        duration: 5000, // time in milliseconds after the snackbar autohides, 0 is disabled
                        showAction: false
                    });
                }

            })

            $(document.body).css({'cursor': 'default'});
        }
    });

    $('.help_desk_delete').on("click", function (event){
        var parent_tr = $(event.target).closest('tr');
        inspection_id = parent_tr.data('inspection-id');
        help_desk_inspection_id = inspection_id;
    })

    $('.inspection-tr .inspection-detail-open').on("click", function(event){
        //check if user is highlighting
        var sel = getSelection().toString();
        if(sel){
            return;
        }
        var ele = $(event.currentTarget).closest('.inspection-tr');
        window.location = ele.data('inspection-detail-url');
    });


});
